// @ts-nocheck
import { getPickUpWarehouses, GetPickupWarehousesApiParameter } from "@store/Framework/Services/StoreWarehouseService";
import { StoreWarehouseCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetPickupWarehousesApiParameter, StoreWarehouseCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadPickupWarehouses: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PickupWarehouses/BeginLoadPickupWarehouses",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = { pickupWarehouses: await getPickUpWarehouses(), pagination: null };
    } catch (error) {
        return false;
    }
};

export const DispatchCompleteLoadPickupWarehouses: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PickupWarehouses/CompleteLoadPickupWarehouses",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadPickupWarehouses,
    RequestDataFromApi,
    DispatchCompleteLoadPickupWarehouses,
];

const loadPickupWarehouses = createHandlerChainRunner(chain, "LoadPickupWarehouses");
export default loadPickupWarehouses;
